import * as React from 'react';
import { Root as Root2, Item as Item2, Indicator } from '../../node_modules/@radix-ui/react-radio-group/dist/index.esm.js';
import { cn } from '../../lib/utils.esm.js';

const RadioGroup = /*#__PURE__*/React.forwardRef(({
  className,
  ...props
}, ref) => {
  return /*#__PURE__*/React.createElement(Root2, {
    className: cn("grid gap-2", className),
    dir: document.documentElement.dir,
    ...props,
    ref: ref
  });
});
RadioGroup.displayName = Root2.displayName;
const RadioGroupItem = /*#__PURE__*/React.forwardRef(({
  className,
  ...props
}, ref) => {
  return /*#__PURE__*/React.createElement(Item2, {
    ref: ref,
    className: cn("voyage-radio-item", className),
    ...props
  }, /*#__PURE__*/React.createElement(Indicator, {
    className: "flex items-center justify-center relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "voyage-radio-item__checked"
  })));
});
RadioGroupItem.displayName = Item2.displayName;

export { RadioGroup, RadioGroupItem };
//# sourceMappingURL=radio-group.esm.js.map
